<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 37.57">
    <path
      class="cls-2"
      d="m5.01,22.53c.6-2.6,2.15-4.41,4.52-5.56.37-.18.76-.08.93.19.17.28.06.64-.33.92-.59.41-1.12.86-1.53,1.45-.72,1.05-.98,2.16-.31,3.34.51.91,1.4,1.28,2.36,1.48,1.54.32,3.05.11,4.54-.33.21-.06.41-.12.63-.1.3.03.54.14.63.45.08.28-.07.49-.28.65-.34.27-.73.46-1.12.64-1.45.63-2.96,1.01-4.62,1.03.49.35,1,.49,1.5.6,1.74.36,3.49.42,5.24,0,.46-.11.81.04.92.39.11.34-.08.69-.51.86-1.78.74-3.64,1.02-5.56.8-.13-.02-.26-.02-.39-.03-.04,0-.07,0-.13,0,.05.16.2.17.31.21,1.6.59,3.23.78,4.91.42.49-.11.92.04,1.03.35.12.32-.09.67-.56.88-4.07,1.83-9.38.37-11.51-3.74-.45-.86-.7-1.77-.81-2.74,0,0-.14-.97.13-2.15Zm6.42,6.75s-.01-.02-.02-.02c0,0-.02.01-.03.02,0,0,.01.02.02.02,0,0,.02-.01.03-.02Z"
    />
    <path
      class="cls-2"
      d="m73.9,33.88c-.11-.41-.06-.79.25-1.1.32-.31.72-.36,1.14-.26.09.02.18.06.32.11,0-.25,0-.47,0-.69-.01-.32.23-.2.38-.22.16-.02.3-.03.3.22-.01.8,0,1.6,0,2.41,0,.39-.36.24-.47.19,0,0-.04-.1-.13-.03s-1.43.41-1.77-.63Zm1.73-.34c0-.32-.25-.56-.57-.56-.32,0-.53.22-.54.55,0,.31.22.55.52.57.31.01.58-.24.58-.55Z"
    />
    <path
      class="cls-2"
      d="m89.04,33.88c-.11-.41-.06-.79.25-1.1.32-.31.72-.36,1.14-.26.09.02.18.06.32.11,0-.25,0-.47,0-.69-.01-.32.23-.2.38-.22.16-.02.3-.03.3.22-.01.8,0,1.6,0,2.41,0,.39-.36.24-.47.19,0,0-.04-.1-.13-.03s-1.43.41-1.77-.63Zm1.73-.34c0-.32-.25-.56-.57-.56-.32,0-.53.22-.54.55,0,.31.22.55.52.57.31.01.58-.24.58-.55Z"
    />
    <path
      class="cls-2"
      d="m77.64,34.56c-.23-.03-.45-.11-.62-.26-.24-.2-.37-.49-.36-.8.03-.47.33-.84.81-.98.73-.21,1.4.16,1.53.83.05.25.01.38-.29.36-.38-.02-.77,0-1.15,0-.05,0-.13,0-.16.04-.05.08.02.13.07.18.27.23.58.24.87.07.28-.16.36.08.44.2.1.15-.07.18-.17.24-.03.02-.07.03-.1.04-.14.04-.45.11-.86.06Zm.74-1.21c-.24-.44-.71-.52-.95-.21-.03.04-.06.11-.06.16.01.08.09.05.15.05.27,0,.54,0,.86,0Z"
    />
    <path
      class="cls-2"
      d="m70.64,34.49c-.42-.18-.65-.55-.63-1,.01-.44.27-.8.71-.94.51-.16,1-.14,1.41.24.55.5.37,1.38-.32,1.69,0,0-.65.22-1.16,0Zm.59-1.51c-.31,0-.55.22-.57.52-.01.32.23.58.54.59.31,0,.54-.21.56-.53.01-.34-.2-.58-.54-.58Z"
    />
    <path
      class="cls-2"
      d="m82.06,34.53c-.28-.13-.44-.32-.4-.64.04-.31.26-.43.53-.5.21-.05.43-.03.64-.05.08,0,.21.07.23-.08.01-.1-.07-.18-.16-.22-.23-.11-.48-.1-.69.01-.26.14-.34,0-.42-.19-.11-.26.15-.23.25-.28.29-.12.61-.12.92-.08.51.06.78.37.79.9,0,.25,0,.5,0,.75,0,.42-.15.57-.51.4,0,0-.12-.06-.25-.02s-.7.11-.94,0Zm.75-.82c-.21,0-.46-.05-.49.24-.02.21.18.24.33.24.22,0,.45-.09.46-.35,0-.2-.2-.08-.29-.12Z"
    />
    <path
      class="cls-2"
      d="m92.24,34.53c-.28-.13-.44-.32-.4-.64.04-.31.26-.43.53-.5.21-.05.43-.03.64-.05.08,0,.21.07.23-.08.01-.1-.07-.18-.16-.22-.23-.11-.48-.1-.69.01-.26.14-.34,0-.42-.19-.11-.26.15-.23.25-.28.29-.12.61-.12.92-.08.51.06.78.37.79.9,0,.25,0,.5,0,.75,0,.42-.15.57-.51.4,0,0-.12-.06-.25-.02s-.7.11-.94,0Zm.75-.82c-.21,0-.46-.05-.49.24-.02.21.18.24.33.24.22,0,.45-.09.46-.35,0-.2-.2-.08-.29-.12Z"
    />
    <path
      class="cls-2"
      d="m58.86,34.51c-.46-.2-.69-.54-.67-1.04.02-.45.29-.79.76-.93.79-.25,1.55.21,1.57.93,0,.18-.04.26-.24.25-.45-.01-.91,0-1.37,0,.09.36.48.49.92.32.09-.04.17-.16.28-.04.08.09.21.17.22.27,0,.12-.16.16-.26.22,0,0-.6.17-1.2.02Zm0-1.16c.28,0,.53,0,.78,0,.07,0,.18.05.21-.06.02-.09-.05-.15-.12-.21-.27-.25-.68-.14-.88.27Z"
    />
    <path
      class="cls-2"
      d="m57.51,34.52c.27-.14.48-.29.46-.61-.01-.32-.23-.45-.51-.52-.2-.05-.4-.08-.6-.11-.09-.02-.17-.04-.17-.15,0-.13.1-.16.19-.17.23-.02.45,0,.67.08.22.08.21-.14.28-.24.07-.1.04-.18-.08-.21-.47-.14-.94-.19-1.4.04-.24.12-.34.32-.33.58.02.27.19.41.42.47.21.06.42.07.63.12.1.02.24.03.22.18-.02.12-.14.15-.25.16-.22.02-.44,0-.63-.1-.25-.13-.31.03-.39.2,0,0-.08.21.18.23s1.16.14,1.31.06Z"
    />
    <path
      class="cls-2"
      d="m68.29,34.42c.13-.07.29-.19.26-.31-.03-.14-.24-.18-.38-.24-.14-.07-.18.09-.26.14-.24.15-.59.12-.75-.09-.18-.23-.19-.49,0-.73.17-.22.5-.26.75-.11.04.02.07.06.11.09.21.16.37-.04.5-.13.15-.11-.04-.22-.12-.3-.32-.3-.95-.36-1.42-.13-.38.18-.59.48-.6.9,0,.26.07.48.21.66.15.19.38.3.62.34.27.04.7.07,1.11-.09Z"
    />
    <path
      class="cls-1"
      d="m15.51,6.09c-1.58-1.24-3.37-1.36-5.25-.98-.24.05-.48.06-.71.03-.3-.04-.55-.19-.63-.51-.07-.32.03-.59.3-.79.28-.2.61-.28.93-.37,4.17-1.19,7.89-.39,11.03,2.63,1.55,1.5,2.43,3.38,2.66,5.54.29,2.73-.53,5.12-2.25,7.21-1.05,1.28-2.38,2.21-3.89,2.88-.3.13-.61.21-.94.17-.55-.06-.81-.51-.58-1.01.13-.28.37-.43.6-.6,1.67-1.21,2.83-2.8,3.48-4.75.03-.08.06-.15,0-.24-.31.4-.6.8-.92,1.19-1.28,1.58-2.91,2.69-4.74,3.53-.23.1-.46.18-.73.12-.35-.09-.63-.27-.7-.64-.07-.37.12-.65.44-.84.83-.5,1.55-1.13,2.2-1.84.98-1.06,1.87-2.19,2.42-3.54.13-.31.23-.62.26-.96.13-.39.04-.77,0-1.16-.17-1.94-1.02-3.52-2.49-4.78-.06-.05-.12-.09-.19-.08,0,0,0,0,0,0-.02-.08.13.03.06.04,0,0,0,0,0,0-.03-.03-.26-.17-.28-.2,0,0,0,0,0,0-.04-.03-.07-.05-.11-.08Z"
    />
    <path
      class="cls-1"
      d="m78.6,21.98c.79-.91,1.76-1.33,2.93-1.31,1.64.02,2.73.97,2.8,2.6.07,1.7.02,3.4.03,5.1,0,.21-.11.22-.27.22-.66,0-1.32-.01-1.98,0-.25,0-.29-.09-.29-.31,0-1.33,0-2.66,0-3.99,0-.11,0-.22,0-.32-.03-.88-.47-1.34-1.26-1.32-.88.02-1.46.57-1.46,1.39,0,1.4-.01,2.8,0,4.2,0,.29-.09.36-.36.35-.6-.02-1.2-.02-1.8,0-.29.01-.39-.06-.38-.37.02-1.29,0-2.59,0-3.88,0-.12,0-.24,0-.36-.03-.88-.48-1.36-1.26-1.34-.87.02-1.45.57-1.45,1.4,0,1.4,0,2.8,0,4.2,0,.27-.07.35-.34.34-.64-.02-1.27-.01-1.91,0-.22,0-.31-.04-.31-.29,0-2.4.01-4.79,0-7.19,0-.27.1-.31.33-.31.58.01,1.15.02,1.73,0,.32-.01.4.12.39.39,0,.14,0,.28,0,.5.75-.73,1.58-1.07,2.56-1.04,1,.03,1.79.4,2.29,1.31Z"
    />
    <path
      class="cls-1"
      d="m30.02,23.46c0-1.59,0-3.19,0-4.78,0-.28.07-.37.36-.36,1.48.01,2.95,0,4.43,0,1.66.01,3.03.99,3.45,2.43.62,2.11-.91,4.28-3.11,4.39-.68.04-1.37.03-2.05.01-.3,0-.41.06-.41.39.03.91,0,1.82.01,2.73,0,.25-.07.33-.32.32-.68-.02-1.37-.02-2.05,0-.26,0-.32-.08-.32-.33.01-1.61,0-3.21,0-4.82Zm2.61-1.79c0,.41,0,.74,0,1.08,0,.17.06.23.23.23.54,0,1.08.02,1.62,0,.65-.03,1.16-.6,1.16-1.24,0-.63-.5-1.14-1.17-1.18-.22-.01-.43-.01-.65,0-.38.01-.88-.16-1.11.06-.25.24-.04.75-.08,1.06Z"
    />
    <path
      class="cls-1"
      d="m35,15.45c-1.83,0-3.43-.56-4.6-2.02-2.05-2.56-1.38-7.11,2.83-8.32,1.85-.53,3.66-.35,5.29.78.76.53.75.54.13,1.2-.28.3-.57.59-.83.9-.18.21-.29.25-.52.04-1.11-.95-2.36-1.13-3.68-.49-1.17.57-1.72,1.8-1.5,3.24.18,1.17,1.19,2.1,2.41,2.29,1.17.19,2.22-.05,3.12-.82.16-.14.21-.06.29.06.34.51.67,1.02,1.03,1.52.13.18.09.28-.07.41-.69.56-1.49.86-2.34,1.06-.52.12-1.04.19-1.57.16Z"
    />
    <path
      class="cls-1"
      d="m45.59,27.73c-1.17,1.02-2.44,1.3-3.81.77-1.4-.54-2.13-1.66-2.33-3.12-.2-1.4.11-2.65,1.12-3.71,1.22-1.27,3.67-1.39,4.87-.16.04.04.09.07.16.12.02-.07.03-.12.04-.16q.04-.65.71-.65c.48,0,.96.02,1.44,0,.28-.01.36.07.36.36-.01,2.2,0,4.41,0,6.61q0,.81-.8.81c-.48,0-.96-.01-1.44,0-.26.01-.34-.08-.31-.32.02-.16,0-.33,0-.55Zm.07-2.99c0-1.18-.65-1.98-1.69-2.09-1.04-.1-1.85.55-2.04,1.64-.16.92.22,1.85.9,2.22,1.35.75,2.82-.18,2.83-1.78Z"
    />
    <path
      class="cls-1"
      d="m79.11,8.36s.04-.05.04-.06c.04-.25-.11-.57.06-.72.18-.16.5-.05.77-.05.46,0,.91,0,1.37,0,.2,0,.3.03.3.27,0,2.41,0,4.82,0,7.22,0,.21-.06.29-.28.29-.66-.01-1.32-.02-1.98,0-.25,0-.31-.09-.29-.31.01-.17,0-.33,0-.55-.17.13-.3.25-.44.34-2.07,1.47-4.89.44-5.57-2.09-.43-1.58-.19-3.06.99-4.3,1.22-1.29,3.71-1.43,4.94-.11.02.03.06.04.1.07Zm.05,3.19c0-.68-.12-1.19-.5-1.61-.5-.56-1.38-.74-2.12-.44-.73.29-1.15,1.05-1.13,2.03.02.88.47,1.6,1.2,1.83,1.35.42,2.57-.37,2.55-1.79Z"
    />
    <path
      class="cls-1"
      d="m90.59,28.75c-1.64,0-2.9-.45-3.84-1.56-1.43-1.69-1.11-4.28.67-5.61,1.57-1.18,4.02-1.26,5.66-.18,1.36.89,1.95,2.18,1.78,3.78-.17,1.56-1.08,2.59-2.5,3.21-.62.27-1.29.38-1.77.37Zm1.7-4.04c0-1.21-.76-2.02-1.89-2.03-1.15,0-1.94.82-1.94,2.02,0,1.17.8,2.02,1.92,2.02,1.23,0,2.02-1.03,1.92-2.01Z"
    />
    <path
      class="cls-1"
      d="m59.73,25.22c-.84,0-1.68,0-2.52,0-.36,0-.38.03-.21.35.39.71,1.04,1,1.8,1.08.75.08,1.46-.03,2.08-.49.15-.11.24-.09.35.06.29.4.59.79.89,1.17.1.13.14.23-.03.35-1.79,1.35-4.78,1.36-6.4-.08-1.24-1.1-1.56-2.5-1.16-4.05.4-1.54,1.45-2.47,2.99-2.84.83-.2,1.67-.18,2.48.08,1.63.53,2.62,1.94,2.58,3.65q-.02.72-.74.72c-.71,0-1.42,0-2.12,0Zm-1.22-1.32c.44,0,.89,0,1.33,0,.42,0,.49-.1.28-.48-.37-.66-.98-.84-1.68-.78-.69.06-1.23.35-1.52,1.03-.09.21,0,.24.19.24.47,0,.94,0,1.4,0Z"
    />
    <path
      class="cls-1"
      d="m52.4,8.43c.57-.52,1.16-.89,1.86-1,1.06-.16,2.07-.1,2.86.76.52.57.7,1.28.71,2.02.03,1.6,0,3.21.01,4.81,0,.23-.08.28-.29.28-.64-.01-1.27-.02-1.91,0-.26,0-.35-.06-.34-.34.01-1.32,0-2.63,0-3.95,0-.1,0-.19,0-.29-.03-.54-.12-1.06-.71-1.3-.56-.22-1.37-.04-1.77.39-.23.25-.34.54-.33.88,0,1.41,0,2.83,0,4.24,0,.27-.06.38-.35.37-.64-.02-1.27-.02-1.91,0-.22,0-.29-.07-.29-.29,0-2.41,0-4.81,0-7.22,0-.23.08-.28.29-.28.61.01,1.22.01,1.84,0,.22,0,.3.06.29.28,0,.19.02.37.03.63Z"
    />
    <path
      class="cls-1"
      d="m68.67,15.45c-2.02.09-3.68-1.21-4.16-2.87-.75-2.58,1.14-5.14,3.83-5.2.98-.02,1.91.1,2.78.57.08.04.17.09.25.14.86.54.87.58.2,1.33-.2.22-.41.44-.59.67-.15.2-.25.17-.42.02-.62-.56-1.35-.8-2.19-.64-.97.19-1.58,1.02-1.52,2.09.05.94.8,1.73,1.73,1.82.77.07,1.46-.1,2.02-.65.18-.18.25-.11.38.04.32.38.63.76.97,1.1.2.21.14.33-.04.49-.63.55-1.38.85-2.19,1.02-.35.07-.71.1-1.05.08Z"
    />
    <path
      class="cls-1"
      d="m40.64,9.91c0-1.7,0-3.4,0-5.1,0-.28.07-.37.36-.36.62.02,1.25.02,1.87,0,.28,0,.34.09.34.35,0,3.4,0,6.8,0,10.2,0,.25-.07.33-.32.32-.64-.02-1.27-.02-1.91,0-.27,0-.34-.08-.34-.34.01-1.69,0-3.38,0-5.06Z"
    />
    <path
      class="cls-1"
      d="m52.88,23.19c0,1.69,0,3.38,0,5.07,0,.26-.05.36-.33.35-.64-.02-1.27-.01-1.91,0-.21,0-.29-.05-.29-.28,0-3.44,0-6.88,0-10.32,0-.24.09-.27.3-.27.65,0,1.3.02,1.94,0,.26,0,.29.1.29.31,0,1.71,0,3.43,0,5.14Z"
    />
    <path
      class="cls-1"
      d="m66.61,21.86c.34-.25.58-.51.88-.71.73-.49,1.53-.58,2.37-.4.17.04.21.08.16.26-.2.72-.4,1.45-.58,2.18-.05.18-.13.19-.28.13-.34-.12-.69-.19-1.06-.13-.89.13-1.38.68-1.38,1.58,0,1.15-.02,2.3,0,3.45,0,.33-.1.4-.4.39-.63-.02-1.27-.01-1.91,0-.18,0-.25-.05-.25-.24,0-2.43,0-4.86,0-7.29,0-.18.04-.26.24-.25.64.01,1.27.01,1.91,0,.21,0,.28.09.29.27,0,.26,0,.52,0,.77Z"
    />
    <path
      class="cls-2"
      d="m15.82,6.31c.08-.01.14.03.19.08,1.47,1.26,2.32,2.85,2.49,4.78.03.39.12.78,0,1.16-1.14,1.15-2.45,2.07-3.9,2.78-.71.35-1.44.65-2.22.82-.57.12-.99-.03-1.13-.38-.15-.39.06-.84.56-1.12.86-.49,1.68-1.03,2.41-1.69.97-.88,1.8-1.86,2.22-3.13.38-1.12.21-2.14-.52-3.08-.05-.06-.16-.11-.09-.23Z"
    />
    <path
      class="cls-1"
      d="m45.3,11.41c0-1.19,0-2.37,0-3.56,0-.25.05-.33.31-.32.65.02,1.3.01,1.94,0,.2,0,.3.03.3.27,0,2.41,0,4.82,0,7.22,0,.22-.06.29-.28.29-.66-.01-1.32-.02-1.98,0-.25,0-.29-.09-.29-.31,0-1.2,0-2.4,0-3.59Z"
    />
    <path
      class="cls-1"
      d="m62.59,11.45c0,1.19,0,2.37,0,3.56,0,.23-.06.31-.3.3-.65-.02-1.3-.01-1.94,0-.22,0-.29-.06-.29-.28,0-2.41,0-4.82,0-7.22,0-.22.06-.29.28-.28.64.01,1.27.02,1.91,0,.26,0,.35.06.34.33-.02,1.2,0,2.4,0,3.59Z"
    />
    <path
      class="cls-2"
      d="m15.2,8.45c0,1-.87,1.81-1.93,1.8-1.07,0-1.93-.83-1.92-1.83,0-1,.88-1.8,1.95-1.8,1.08,0,1.91.8,1.91,1.82Z"
    />
    <path
      class="cls-1"
      d="m61.37,3.58c.24-.02.46.01.68.09.44.16.73.44.77.93.05.54-.13.98-.63,1.22-.58.28-1.19.27-1.77-.01-.45-.21-.62-.62-.6-1.09.02-.5.35-.9.84-1.05.23-.07.47-.11.7-.08Z"
    />
    <path
      class="cls-1"
      d="m45.4,6.66c-.09,0-.12-.04-.16-.09-.19-.27-.38-.55-.57-.82-.09-.13-.03-.18.07-.25.83-.61,1.66-1.22,2.48-1.84.16-.12.24-.09.35.06.29.4.58.79.88,1.18.11.15.09.21-.07.29-.94.47-1.88.94-2.82,1.41-.05.03-.11.05-.15.07Z"
    />
    <path
      class="cls-2"
      d="m53.56,34.57c-.19,0-.32,0-.45,0-.2,0-.33-.04-.37-.24-.06-.3-.25-.32-.53-.33-.15,0-.31,0-.47,0-.33,0-.52.05-.64.39q-.05.14-.76.14c.4-.84.8-1.67,1.2-2.5.1-.2.7-.2.8,0,.4.82.79,1.65,1.21,2.54Zm-1.62-2.01c-.09.19-.15.3-.2.42-.25.56-.25.55.36.53.2,0,.26-.06.16-.24-.1-.21-.19-.42-.32-.71Z"
    />
    <path
      class="cls-2"
      d="m63.8,33.86c.15-.33.3-.6.39-.89.13-.41.37-.58.84-.43-.26.58-.54,1.17-.79,1.76-.09.21-.2.27-.42.28-.3.01-.44-.09-.55-.36-.23-.56-.49-1.11-.74-1.67.61-.13.63-.13.86.41.1.24.21.48.32.72.02.04.04.09.09.18Z"
    />
    <path
      class="cls-2"
      d="m85.15,32.51q.66-.05.9.5c.11.26.23.52.36.81.21-.28.32-.57.42-.86.14-.41.37-.58.84-.44-.17.39-.35.78-.52,1.17-.07.15,0,0-.2.46-.2.49-.4.42-.74.4-.1,0-.16-.04-.19-.13-.29-.64-.57-1.28-.86-1.93Z"
    />
    <path
      class="cls-2"
      d="m81.22,33.16c0,.39-.01.79,0,1.18.01.29-.18.22-.34.22-.16,0-.33.06-.33-.23.02-.79.02-1.58,0-2.37,0-.3.18-.24.36-.25.19-.01.32,0,.31.26-.02.39,0,.79,0,1.18Z"
    />
    <path
      class="cls-2"
      d="m54.44,33.13c0,.39-.02.79,0,1.18.02.3-.16.26-.34.25-.16,0-.33.05-.32-.23.02-.79.02-1.58,0-2.37,0-.31.19-.23.35-.25.19-.01.32,0,.31.26-.02.38,0,.76,0,1.15Z"
    />
    <path
      class="cls-2"
      d="m60.93,33.54c0-.23,0-.46,0-.68,0-.33.31-.55.54-.34.2.18.29.05.43.02.14-.02.35-.19.4.07.04.18.13.46-.27.46-.27,0-.43.2-.43.48,0,.26-.02.53,0,.79.03.28-.16.24-.32.23-.16,0-.38.08-.35-.24.02-.26,0-.53,0-.79Z"
    />
    <path
      class="cls-2"
      d="m65.95,33.53c0,.23-.02.46,0,.68.04.32-.1.38-.38.37-.22,0-.29-.06-.28-.28.02-.51.02-1.03,0-1.54,0-.26.12-.27.31-.26.17.01.38-.06.35.25-.02.26,0,.53,0,.79Z"
    />
    <path
      class="cls-2"
      d="m87.92,33.56c0-.26.02-.53,0-.79-.02-.27.12-.29.32-.28.18,0,.36-.04.34.26-.02.53-.02,1.05,0,1.58.01.32-.2.22-.36.24-.19.02-.33,0-.31-.25.02-.25,0-.5,0-.75Z"
    />
    <path
      class="cls-2"
      d="m69.6,33.52c0,.22,0,.43,0,.65,0,.39-.16.5-.55.4-.09-.02-.11-.07-.11-.15,0-.59,0-1.17,0-1.76,0-.25.19-.17.31-.16.13,0,.34-.11.35.16,0,.29,0,.57,0,.86Z"
    />
    <path
      class="cls-2"
      d="m69.27,31.56c.21.01.39.07.4.32.01.26-.16.36-.39.36-.23,0-.41-.09-.4-.35,0-.24.18-.31.4-.33Z"
    />
    <path
      class="cls-2"
      d="m88.22,32.23c-.18-.01-.37-.07-.37-.32,0-.26.16-.35.4-.36.22,0,.4.09.4.32,0,.24-.16.35-.43.36Z"
    />
    <path
      class="cls-2"
      d="m94.73,34.57c-.18-.01-.37-.07-.37-.32,0-.26.16-.35.4-.36.22,0,.4.09.4.32,0,.24-.16.35-.43.36Z"
    />
    <path
      class="cls-2"
      d="m65.61,32.23c-.22-.01-.39-.1-.39-.34,0-.25.19-.34.42-.34.21,0,.39.09.38.33,0,.26-.19.34-.42.34Z"
    />
    <path class="cls-2" d="m15.51,6.09s.07.05.11.08c-.04-.03-.07-.05-.11-.08Z" />
  </svg>
</template>

<script>
export default {
  name: 'CoPalermoLogo'
}
</script>
<style scoped>

.cls-1 {
  fill: #409bd5;
}

.cls-1,
.cls-2 {
  stroke-width: 0px;
}

.cls-2 {
  fill: #2c4897;
}
</style>
